import { useContextualRouting } from './useContextualRouting';
import useParams from './useParams';

export { useParams, useContextualRouting };
